import {
  CloseFullscreen as CloseFullscreenIcon,
  Fullscreen as FullscreenIcon,
  OpenInFull as OpenInFullIcon,
} from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const ViewModeToggle = ({
  viewMode,
  onViewModeChange,
  disabled = false,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  return (
    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={onViewModeChange}
      size={"small"}
      aria-label={"view mode"}
      disabled={disabled}
      sx={{
        height: "30.75px",
        "& .MuiToggleButton-root": {
          color: "text.secondary",
          borderColor: "divider",
          padding: "4px 10px",
          "&.Mui-selected": {
            color: "text.primary",
            backgroundColor: "action.selected",
            "&:hover": {
              backgroundColor: "action.selected",
            },
          },
        },
      }}
    >
      <ToggleButton value={"inpage"} aria-label={"in page view"}>
        <Tooltip
          title={translateLabels(labels.VIEW_MODE_TOGGLE_IN_PAGE, {
            default: "In page view",
          })}
        >
          <CloseFullscreenIcon fontSize={"small"} />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value={"fullpage"} aria-label={"full page view"}>
        <Tooltip
          title={translateLabels(labels.VIEW_MODE_TOGGLE_FULL_PAGE, {
            default: "Full page view",
          })}
        >
          <OpenInFullIcon fontSize={"small"} />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value={"fullscreen"} aria-label={"fullscreen view"}>
        <Tooltip
          title={translateLabels(labels.VIEW_MODE_TOGGLE_FULLSCREEN, {
            default: "Fullscreen view",
          })}
        >
          <FullscreenIcon fontSize={"small"} />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
export default ViewModeToggle;
